<template>

    <div class="my-4">
        <div v-show="!done && checklist.started" class="bg-yellow-lighter shadow-md p-4" style="transform: rotate(1deg)">

            <h3>Getting Started</h3>

            <ol class="list-reset">
                <li class="py-2 text-grey-dark"><i class="text-green fa fa-check"></i>
                    visit the starting page
                </li>
                <li class="py-2 text-grey-dark"><i class="text-green fa fa-check"></i>
                    start a new selection
                </li>
                <li :class="{'text-grey-dark': checklist.database}">
                    <i class="py-2 text-grey fa fa-check" :class="{'text-green': checklist.database}"></i>
                    select a database
                </li>
                <li :class="{'text-grey-dark': checklist.addSeriesToReport}">
                    <i class="py-2 text-grey fa fa-check" :class="{'text-green': checklist.addSeriesToReport}"></i>
                    add your time series
                </li>
                <li :class="{'text-grey-dark': checklist.showReport}">
                    <i class="py-2 text-grey fa fa-check" :class="{'text-green': checklist.showReport}"></i>
                    view your selection
                </li>
            </ol>
        </div>

        <div v-show="done">

        </div>
    </div>

</template>

<script>

    export default {

        inject: ['report'],

        data: function () {
            return {
                checklist: {
                    started: false,
                    database: false,
                    showReport: false,
                    addSeriesToReport: false,
                },
            }
        },

        watch: {
            'report.selected': function (val) {
                if (this.checklist.addSeriesToReport || val.length === 0) {
                    return;
                }
                this.checklist.addSeriesToReport = true;
                this.update();
            },
        },

        computed: {
            done: function () {
                return this.checklist.database && this.checklist.showReport && this.checklist.addSeriesToReport;
            },
        },

        mounted: function () {
            // get server data? ugly!
            let session = sessionStorage.getItem('checklist');

            if (session !== null) {
                this.checklist = JSON.parse(session);
            }

            this.isStarted();
            this.isDatabase();
            this.isReport();
        },

        methods: {
            update: function () {
                sessionStorage.setItem('checklist', JSON.stringify(this.checklist))
            },
            isStarted: function () {
                const href = window.location.href;
                if (this.checklist.started) {
                    return;
                }
                if (href.match('/databases/') || href.match('/sources')) {
                    this.checklist.started = true;
                    this.update();
                }
            },
            isDatabase: function () {
                const href = window.location.href;
                if (!this.checklist.database && href.match('/databases/')) {
                    this.checklist.database = true;
                    this.update();
                }
            },
            isReport: function () {
                const href = window.location.href;
                if (!this.checklist.showReport && href.match('/dashboards/')) {
                    this.checklist.showReport = true;
                    this.update();
                }
            },
        }

    }

</script>